import React, { createContext, useContext, useState, ReactNode } from 'react';

interface UnsavedChangesContextType {
  hasUnsavedChanges: boolean;
  setHasUnsavedChanges: (hasChanges: boolean) => void;
  onSave: (() => void) | null;
  setOnSave: (saveFunction: (() => void) | null) => void;
  isSubmitting: boolean;
  setIsSubmitting: (isSubmitting: boolean) => void;
}

const UnsavedChangesContext = createContext<UnsavedChangesContextType | undefined>(undefined);

export const useUnsavedChanges = () => {
  const context = useContext(UnsavedChangesContext);
  if (!context) {
    throw new Error('useUnsavedChanges must be used within an UnsavedChangesProvider');
  }
  return context;
};

interface UnsavedChangesProviderProps {
  children: ReactNode;
}

export const UnsavedChangesProvider: React.FC<UnsavedChangesProviderProps> = ({ children }) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [onSave, setOnSave] = useState<(() => void) | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <UnsavedChangesContext.Provider value={{ 
      hasUnsavedChanges, 
      setHasUnsavedChanges, 
      onSave, 
      setOnSave,
      isSubmitting,
      setIsSubmitting
    }}>
      {children}
    </UnsavedChangesContext.Provider>
  );
};
